document.addEventListener('DOMContentLoaded', () => {
  const pressGridItems = document.querySelectorAll('[data-press-grid-item="true"]');
  if (pressGridItems.length === 0) return;

  pressGridItems.forEach(card => {
    const swatches = card.querySelectorAll('span.color-swatch[data-variant-id]');
    const badgeWrapper = card.querySelector('.flex-inline');
    const mainImageWrapper = card.querySelector('img[data-main-image]');
    const secondaryImageWrapper = card.querySelector('img[data-secondary-image]');
    const imageMask = card.querySelector('.grid-product__image-mask');
    const priceElement = card.querySelector('[data-press-grid-price]');
    const atcButton = card.querySelector('[data-press-grid-atc]');
    const initialVariantId = card.getAttribute('data-initial-variant-id');

    if (swatches.length === 0) return;

    // Remove any existing is-active classes first (from Liquid template)
    swatches.forEach(s => s.classList.remove('is-active'));

    // Initialize with initial variant
    let selectedVariantId = initialVariantId;
    if (initialVariantId) {
      const initialSwatch = Array.from(swatches).find(swatch => 
        swatch.getAttribute('data-variant-id') === initialVariantId
      );
      if (initialSwatch) {
        initialSwatch.classList.add('is-active');
        updateCardForVariant(initialSwatch);
      }
    } else {
      // If no initial variant specified, use the first available swatch
      const firstAvailableSwatch = Array.from(swatches).find(swatch => 
        swatch.getAttribute('data-variant-available') === 'true' && !swatch.classList.contains('disabled')
      );
      if (firstAvailableSwatch) {
        selectedVariantId = firstAvailableSwatch.getAttribute('data-variant-id');
        firstAvailableSwatch.classList.add('is-active');
        updateCardForVariant(firstAvailableSwatch);
      }
    }

    // Add click handlers to swatches
    swatches.forEach(swatch => {
      const variantAvailable = swatch.getAttribute('data-variant-available') === 'true';
      
      // Skip disabled/out of stock swatches - don't add click handlers
      if (!variantAvailable || swatch.classList.contains('disabled')) {
        return;
      }

      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        
        const variantId = swatch.getAttribute('data-variant-id');
        if (!variantId) return;

        // Remove active class from all swatches
        swatches.forEach(s => s.classList.remove('is-active'));
        
        // Add active class to clicked swatch
        swatch.classList.add('is-active');
        
        // Update selected variant
        selectedVariantId = variantId;
        
        // Update card content
        updateCardForVariant(swatch);
      });
    });

    // Add to cart button handler
    if (atcButton) {
      atcButton.addEventListener('click', function(event) {
        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          return;
        }

        // Disable button during request
        this.disabled = true;
        const originalText = this.querySelector('[data-add-to-cart-text]').textContent;
        this.querySelector('[data-add-to-cart-text]').textContent = 'Adding...';

        // Define the payload with the selected variant ID and quantity
        const payload = {
          id: variantId,
          quantity: 1
        };

        // Make the fetch request to add the item to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error adding item to cart');
          }
          return response.json();
        })
        .then(data => {
          // Re-enable button
          this.disabled = false;
          this.querySelector('[data-add-to-cart-text]').textContent = 'Added!';
          
          // Dispatch cart update event
          document.dispatchEvent(new CustomEvent('cart:build'));
          
          // Open the cart drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          
          // Reset button text after a short delay
          setTimeout(() => {
            this.querySelector('[data-add-to-cart-text]').textContent = originalText;
          }, 2000);
        })
        .catch(error => {
          console.error('Error:', error);
          // Re-enable button on error
          this.disabled = false;
          this.querySelector('[data-add-to-cart-text]').textContent = originalText;
        });
      });
    }

    function updateCardForVariant(swatch) {
      const mainImage = swatch.getAttribute('data-main-image');
      const secondImage = swatch.getAttribute('data-secondary-image');
      const variantPrice = swatch.getAttribute('data-variant-price');
      const variantAvailable = swatch.getAttribute('data-variant-available') === 'true';
      const variantId = swatch.getAttribute('data-variant-id');
      const badgeText = swatch.getAttribute('data-badge-text');
      const badgeColor = swatch.getAttribute('data-badge-text-color');

      // Update images
      if (mainImage && mainImageWrapper) {
        mainImageWrapper.src = mainImage;
        mainImageWrapper.setAttribute('srcset', `${mainImage}&width=360 360w, ${mainImage}&width=540 540w, ${mainImage}&width=720 720w, ${mainImage}&width=1000 1000w`);
      }

      if (secondaryImageWrapper) {
        const secondaryContainer = secondaryImageWrapper.parentElement;
        if (secondImage) {
          secondaryImageWrapper.src = secondImage;
          secondaryImageWrapper.setAttribute('srcset', `${secondImage}&width=360 360w, ${secondImage}&width=540 540w, ${secondImage}&width=720 720w, ${secondImage}&width=1000 1000w`);
          if (secondaryContainer) secondaryContainer.style.display = '';
          if (imageMask) imageMask.classList.remove('no-secondary-image');
        } else {
          if (secondaryContainer) secondaryContainer.style.display = 'none';
          if (imageMask) imageMask.classList.add('no-secondary-image');
        }
      }

      // Update price
      if (variantPrice && priceElement && typeof theme !== 'undefined' && theme.Currency) {
        const formattedPrice = theme.Currency.formatMoney(variantPrice, theme.settings.moneyFormat);
        priceElement.textContent = formattedPrice;
      }

      // Update badge
      if (badgeWrapper) {
        // Remove any existing badges
        const oldBadge = badgeWrapper.querySelector('.tagged-product');
        const oldBar = badgeWrapper.querySelector('.bar');
        if (oldBadge) oldBadge.remove();
        if (oldBar) oldBar.remove();

        // Add new badge if present
        if (badgeText && badgeColor) {
          const newBadge = document.createElement('div');
          newBadge.className = 'grid-product__vendor tagged-product';
          newBadge.style.color = badgeColor;
          newBadge.textContent = badgeText;
          const newBar = document.createElement('div');
          newBar.className = 'bar';
          newBar.textContent = '|';
          badgeWrapper.prepend(newBar);
          badgeWrapper.prepend(newBadge);
        }
      }

      // Update ATC button
      if (atcButton && variantId) {
        atcButton.setAttribute('data-variant-id', variantId);
        atcButton.disabled = !variantAvailable;
        
        const atcText = atcButton.querySelector('[data-add-to-cart-text]');
        if (atcText) {
          if (variantAvailable) {
            atcText.textContent = atcText.getAttribute('data-default-text') || 'Add to cart';
          } else {
            atcText.textContent = 'Sold out';
          }
        }
      }
    }
  });
});